import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/boxes.png'


const _withScopeId = n => (_pushScopeId("data-v-6a7344db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod-download-card px-4 py-3 mb-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-icon col-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "boxes"
  })
], -1))
const _hoisted_4 = { class: "download-desc col d-flex justify-content-between" }
const _hoisted_5 = { class: "d-flex flex-column col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "pb-1" }, "Информация о файлах модификации", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createTextVNode("Проверено на вирусы "),
  /*#__PURE__*/_createElementVNode("i", {
    style: {"color":"#14966d"},
    class: "fas fa-shield-check"
  })
], -1))
const _hoisted_8 = { class: "d-flex col-md-6 col-sm-12 flex-column align-items-end justify-content-between" }
const _hoisted_9 = { class: "mod-price px-3 d-flex fw-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("small", null, "Скачиваний: " + _toDisplayString(_ctx.data.downloads), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.data.size), 1),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadAction && _ctx.downloadAction(...args)), ["prevent"])),
            class: "btn btn-download px-3 mt-2 py-0 text-nowrap"
          }, "Скачать мод")
        ])
      ])
    ])
  ]))
}